import * as React from 'react';
import { useState } from 'react';
import SupportTicket from '../models/supportTicket';
import SupportFilters from '../models/supportFilters';
import SelectedSupportFilters from '../models/selectedSupportFilters';

interface SupportState {
  loading: boolean;
  tickets: SupportTicket[];
  currentPage: number;
  totalTickets: number;
  pageSize: number;
  orderDirection: 'asc' | 'desc' | null;
  orderColumn: string;
  searchQuery: string | null;
  allFilters: SupportFilters;
  selectedFilters: SelectedSupportFilters;
  localSelectedFilters: SelectedSupportFilters;
}

interface ContextValue extends SupportState {
  dispatch: any;
}

const defaultState: SupportState = {
  loading: false,
  tickets: [],
  currentPage: 0,
  totalTickets: 1,
  pageSize: 60,
  orderDirection: null,
  orderColumn: '',
  searchQuery: '',
  allFilters: {
    organizations: [],
    types: [],
    statuses: [],
    requesters: []
  },
  selectedFilters: {
    requestTypeSelected: [],
    statusSelected: [],
    requesterSelected: [],
    organizationSelected: [],
    createdDateStart: null,
    createdDateEnd: null
  },
  localSelectedFilters: {
    requestTypeSelected: [],
    statusSelected: [],
    requesterSelected: [],
    organizationSelected: [],
    createdDateStart: null,
    createdDateEnd: null
  }
};

const SupportContext = React.createContext<ContextValue>(null);

const SupportConsumer = SupportContext.Consumer;

const SupportProvider = props => {
  const [state, setState] = useState<SupportState>(defaultState);

  const dispatch = (newValue: any) => {
    setState(prevState => {
      return { ...prevState, ...newValue };
    });
  };

  return <SupportContext.Provider value={{ ...state, dispatch }}>{props.children}</SupportContext.Provider>;
};

export { SupportContext, SupportProvider, SupportConsumer };
